import { render, staticRenderFns } from "./deleteHsfo.vue?vue&type=template&id=7b6e0463"
import script from "./deleteHsfo.vue?vue&type=script&lang=js"
export * from "./deleteHsfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports